import {apiGet} from '../../utils/api';
import {isAuthenticated} from '../auth';
import {initSortable} from '../block-system/block-manager/block-sortable';
import {loadContentForNewElements} from '../content-editor-src';
import {createAndTrackBlock} from '../block-system/block-manager/block-renderer';
import {config} from '../../config/app-config';

export class CoursesLoader {
    constructor() {
        console.log('[CoursesLoader] Инициализация начата');
        this.currentOffset = 0;
        this.itemsPerPage = 4;
        this.isLoading = false;
        this.hasMoreCourses = true;
        this.container = null;
        this.loadMoreButton = null;
        this.isAuthenticated = isAuthenticated();
        this.initialized = false;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.init(), 100);
            });
        } else {
            setTimeout(() => this.init(), 100);
        }
    }

    init() {
        if (this.initialized) {
            console.log('[CoursesLoader] Уже инициализирован, пропускаем');
            return;
        }

        console.log('[CoursesLoader] init() - начало');

        try {
            const {initializeBlockCounters} = require('../block-system/block-manager/block-state');
            initializeBlockCounters();
            console.log('[CoursesLoader] Счетчики блоков инициализированы');
        } catch (error) {
            console.error('[CoursesLoader] Ошибка инициализации счетчиков:', error);
        }

        if (window.location.pathname.match(/courses(\.html)?$/)) {
            console.log('[CoursesLoader] Страница courses - ищем контейнер');
            this.initElements();
        } else {
            console.log('[CoursesLoader] Не страница courses, пропускаем инициализацию');
        }
    }

    initElements() {
        this.container = document.querySelector('[data-section="courses-section"]');
        this.loadMoreButton = document.querySelector('.load-more-');

        console.log('[CoursesLoader] Контейнер найден:', !!this.container);
        console.log('[CoursesLoader] Кнопка загрузки найдена:', !!this.loadMoreButton);

        if (this.container) {
            this.initialized = true;
            console.log('[CoursesLoader] Настраиваем обработчики');

            if (this.container.dataset.ssr === 'true') {
                this.currentOffset = this.container.querySelectorAll('[data-block-name]').length;
                console.log(`[CoursesLoader] SSR контент обнаружен: ${this.currentOffset} курсів`);
            } else {
                this.clearContainer();
            }

            if (this.isAuthenticated) {
                initSortable(this.container);
            }

            this.setupLoadMoreButton();

            if (this.container.dataset.ssr !== 'true') {
                this.loadInitialCourses();
            }
        } else {
            console.warn('[CoursesLoader] Контейнер courses-section не найден!');
        }
    }

    clearContainer() {
        const nonBlockElements = Array.from(this.container.children).filter(
            child => !child.hasAttribute('data-block-name')
        );
        this.container.innerHTML = '';
        nonBlockElements.forEach(element => this.container.appendChild(element));
        console.log('[CoursesLoader] Контейнер очищен, сохранены не блочные элементы');
    }

    setupLoadMoreButton() {
        if (this.loadMoreButton) {
            const newButton = this.loadMoreButton.cloneNode(true);
            this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
            this.loadMoreButton = newButton;

            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('[CoursesLoader] Кнопка "загрузить больше" нажата');
                this.loadMoreCourses();
            });

            console.log('[CoursesLoader] Кнопка "загрузить больше" настроена');
        }
    }

    async loadInitialCourses() {
        console.log('[CoursesLoader] loadInitialCourses() - начало');

        try {
            this.currentOffset = 0;
            this.hasMoreCourses = true;
            await this.loadCoursesChunk(0);
        } catch (error) {
            console.error('[CoursesLoader] Ошибка при загрузке начальных курсов:', error);
            this.renderErrorState();
        }
    }

    async loadMoreCourses() {
        if (this.isLoading || !this.hasMoreCourses) {
            console.log('[CoursesLoader] Загрузка уже идет или нет больше курсов');
            return;
        }

        console.log('[CoursesLoader] loadMoreCourses() - загружаем еще курсы');
        console.log(`[CoursesLoader] Текущий offset: ${this.currentOffset}`);

        try {
            await this.loadCoursesChunk(this.currentOffset);
        } catch (error) {
            console.error('[CoursesLoader] Ошибка при загрузке дополнительных курсов:', error);
            this.showLoadMoreError();
        }
    }

    async loadCoursesChunk(offset) {
        console.log(`[CoursesLoader] loadCoursesChunk() - offset: ${offset}, limit: ${this.itemsPerPage}`);

        this.isLoading = true;
        this.updateLoadMoreButton('loading');

        try {
            let apiUrl = `${config.api.paths.coursesOffset}?offset=${offset}&limit=${this.itemsPerPage}`;
            if (!this.isAuthenticated) {
                apiUrl += `&status=published`;
            }
            console.log('[CoursesLoader] API URL:', apiUrl);

            const response = await apiGet(apiUrl, {auth: false});
            console.log('[CoursesLoader] Ответ получен:', response);

            let courseItems = Array.isArray(response) ? response : [];
            console.log('[CoursesLoader] Количество курсов от API:', courseItems.length);

            if (courseItems.length > 0) {
                await this.processCoursesChunk(courseItems);

                this.currentOffset += courseItems.length;
                console.log(`[CoursesLoader] Offset обновлен до: ${this.currentOffset}`);

                if (courseItems.length < this.itemsPerPage) {
                    console.log('[CoursesLoader] Получено меньше курсов чем запрашивали - это последний чанк');
                    this.hasMoreCourses = false;
                    this.updateLoadMoreButton('no-more');
                } else {
                    this.updateLoadMoreButton('ready');
                }
            } else {
                if (offset === 0) {
                    console.log('[CoursesLoader] Это был первый запрос - показываем пустое состояние');
                    this.renderEmptyState();
                }
                this.hasMoreCourses = false;
                this.updateLoadMoreButton('no-more');
            }

            // Завантажуємо контент для всіх блоків у контейнері
            loadContentForNewElements(this.container.querySelectorAll('[data-content]'));
        } catch (error) {
            console.error('[CoursesLoader] Ошибка при загрузке чанка курсов:', error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async processCoursesChunk(courseItems) {
        console.log(`[CoursesLoader] processCoursesChunk() - обрабатываем ${courseItems.length} курсов`);

        for (let i = 0; i < courseItems.length; i++) {
            const course = courseItems[i];
            const blockData = {
                id: course.id,
                class_name: 'course-card',
                data_block_name: course.slug,
                order: this.currentOffset - courseItems.length + i
            };

            console.log(`[CoursesLoader] Создаем блок для ${course.slug}`);
            console.log(`[CoursesLoader] Окей вот айди${blockData.id}`);

            const blockElement = createAndTrackBlock(blockData, this.container);
            if (blockElement) {
                blockElement.setAttribute('data-course-id', course.id);
                blockElement.setAttribute('data-course-status', course.status || 'draft');
                blockElement.setAttribute('data-course-slug', course.slug);

                if (this.isAuthenticated && window.courseManager && course.id) {
                    window.courseManager.addStatusControlsToBlock(blockElement, course.id);
                    console.log(`[CoursesLoader] Добавлены контролы статуса для ${course.slug}`);
                } else if (!this.isAuthenticated) {
                    const statusIndicator = blockElement.querySelector('.course-status-indicator');
                    if (statusIndicator) {
                        statusIndicator.remove();
                    }
                }

                this.updateCourseLink(blockElement, course.slug, course.status);
            } else {
                console.warn(`[CoursesLoader] Не удалось создать блок для ${course.slug}`);
            }
        }
    }

    updateCourseLink(blockElement, courseSlug, courseStatus) {
        const courseLink = blockElement.querySelector('a.news-link-to-feed-container');
        if (courseLink && courseSlug) {
            // ИСПРАВЛЕНИЕ: Ссылка всегда активна если есть slug
            // Только для пользователей без авторизации показываем неактивные ссылки
            const shouldActivateLink = courseStatus === 'published' || this.isAuthenticated;
            const dynamicUrl = shouldActivateLink ? `/course/${courseSlug}` : '#';

            courseLink.href = dynamicUrl;
            courseLink.setAttribute('data-page', courseSlug);
            courseLink.classList.toggle('active', shouldActivateLink);
            courseLink.classList.toggle('inactive', !shouldActivateLink);

            // ИСПРАВЛЕНИЕ: Только для неавторизованных пользователей блокируем клики
            if (!shouldActivateLink) {
                courseLink.style.pointerEvents = 'none';
                courseLink.style.opacity = '0.5';
            } else {
                courseLink.style.pointerEvents = '';
                courseLink.style.opacity = '';
            }

            console.log(`[CoursesLoader] Ссылка обновлена для ${courseSlug}: ${dynamicUrl} (authenticated: ${this.isAuthenticated})`);
        }
    }

    updateLoadMoreButton(state) {
        if (!this.loadMoreButton) return;

        switch (state) {
            case 'loading':
                this.loadMoreButton.textContent = 'завантажується...';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                break;

            case 'ready':
                this.loadMoreButton.textContent = 'завантажити більше';
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.style.opacity = '1';
                this.loadMoreButton.style.display = 'block';
                break;

            case 'no-more':
                this.loadMoreButton.textContent = 'усі курси завантажено';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                setTimeout(() => {
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = 'none';
                    }
                }, 3000);
                break;
        }
    }

    showLoadMoreError() {
        if (this.loadMoreButton) {
            this.loadMoreButton.textContent = 'помилка завантаження';
            this.loadMoreButton.disabled = false;
            this.loadMoreButton.style.opacity = '1';

            setTimeout(() => {
                this.updateLoadMoreButton('ready');
            }, 3000);
        }
    }

    renderEmptyState() {
        console.log('[CoursesLoader] renderEmptyState()');
        this.container.innerHTML = `
            <div class="courses-empty-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Курси скоро з'являться</h3>
                <p>Наразі немає активних курсів</p>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    renderErrorState() {
        console.log('[CoursesLoader] renderErrorState()');
        this.container.innerHTML = `
            <div class="courses-error-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Не вдалося завантажити курси</h3>
                <p>Спробуйте оновити сторінку</p>
                <button onclick="location.reload()" style="
                    padding: 10px 20px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-top: 10px;
                ">Оновити сторінку</button>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    async reload() {
        console.log('[CoursesLoader] Перезагрузка курсов');
        this.currentOffset = 0;
        this.hasMoreCourses = true;
        this.clearContainer();
        await this.loadInitialCourses();
    }
}

export const coursesLoader = new CoursesLoader();